import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useLeadFunnelStages } from './hooks/useLeadFunnelStages';
import { FunnelStageTreeSelect } from './ui/FunnelStageTreeSelect';

import './LeadFunnelStages.scss';

export const LeadFunnelStages = () => {
  const {
    rows,
    hasStages,
    availableFunnelsForAdd,
    isFunnelsLoading,
    isFunnelsError,
    isMutating,
    canEdit,
    addStage,
    changeStage,
    removeStage,
  } = useLeadFunnelStages();

  if (!canEdit) return null;

  return (
    <section className="LeadFunnelStages">
      <h4 className="LeadFunnelStages__title">Воронки продаж</h4>

      {isFunnelsError ? (
        <p className="LeadFunnelStages__message">
          Не удалось загрузить воронки
        </p>
      ) : (
        <>
          {hasStages ? (
            <ul className="LeadFunnelStages__list">
              {rows.map((row) => (
                <li
                  className="LeadFunnelStages__chip"
                  key={row.stageId}
                  style={{
                    background: row.background,
                    color: row.textColor,
                  }}
                >
                  <FunnelStageTreeSelect
                    funnels={row.funnel ? [row.funnel] : []}
                    selectedStageId={row.stageId}
                    disabled={isMutating}
                    emptyText="Этапы недоступны"
                    onSelect={(newStageId) =>
                      changeStage(row.stageId, newStageId)
                    }
                  >
                    <button
                      className="LeadFunnelStages__chip-trigger"
                      type="button"
                      disabled={isMutating}
                      title={
                        row.funnelName
                          ? `${row.funnelName} — ${row.stageName}`
                          : row.stageName
                      }
                    >
                      {row.funnelName && (
                        <span className="LeadFunnelStages__funnel-name">
                          {row.funnelName}
                        </span>
                      )}
                      <span className="LeadFunnelStages__stage-name">
                        {row.stageName}
                      </span>
                    </button>
                  </FunnelStageTreeSelect>

                  <Button
                    className="LeadFunnelStages__remove"
                    type="text"
                    size="small"
                    icon={<DeleteOutlined />}
                    aria-label="Удалить этап"
                    disabled={isMutating}
                    style={{ color: row.textColor }}
                    onClick={() => removeStage(row.stageId)}
                  />
                </li>
              ))}
            </ul>
          ) : (
            !isFunnelsLoading && (
              <p className="LeadFunnelStages__message">
                Этапы воронок не назначены
              </p>
            )
          )}

          {availableFunnelsForAdd.length > 0 && (
            <FunnelStageTreeSelect
              funnels={availableFunnelsForAdd}
              disabled={isMutating}
              emptyText="Нет доступных воронок"
              onSelect={addStage}
            >
              <Button
                className="LeadFunnelStages__add"
                type="dashed"
                size="small"
                icon={<PlusOutlined />}
                disabled={isMutating || isFunnelsLoading}
                block
              >
                Добавить этап
              </Button>
            </FunnelStageTreeSelect>
          )}
        </>
      )}
    </section>
  );
};
